/**
 * Collection stage recommendation API permissions (design §11.2).
 */

export const COLLECTION_RECOMMENDATION_READ_PERMISSION = 'collection_recommendation:read' as const;
export const COLLECTION_RECOMMENDATION_DISMISS_PERMISSION =
  'collection_recommendation:dismiss' as const;
export const COLLECTION_RECOMMENDATION_EVALUATE_PERMISSION =
  'collection_recommendation:evaluate' as const;

/** Bounded V1 read fallback for operators with AR collection surface access. */
export const COLLECTION_RECOMMENDATION_READ_FALLBACK_PERMISSION = 'ar_collection:read' as const;

export const COLLECTION_RECOMMENDATION_PERMISSIONS = [
  COLLECTION_RECOMMENDATION_READ_PERMISSION,
  COLLECTION_RECOMMENDATION_DISMISS_PERMISSION,
  COLLECTION_RECOMMENDATION_EVALUATE_PERMISSION,
] as const;

export type CollectionRecommendationPermission =
  (typeof COLLECTION_RECOMMENDATION_PERMISSIONS)[number];

export function isCollectionRecommendationPermission(
  permission: string
): permission is CollectionRecommendationPermission {
  return (COLLECTION_RECOMMENDATION_PERMISSIONS as readonly string[]).includes(permission);
}
